<template>
  <div class="column tw-py-1">
    <div class="col-auto">
      <div class="row items-center">
        <div class="col">
          <span class="tw-text-[10px] tw-font-semibold tw-uppercase tw-tracking-wider tw-text-primary">BUSCA GERAL</span>
        </div>

        <div
          data-testid="atendimento-adicionar"
          v-if="!isPaused"
          class="col-auto cursor-pointer tw-rounded-full tw-p-1 tw-transition hover:tw-bg-greyc-4"
          @click="handleAdd"
        >
          <NumKeyboardAndPlus class="tw-block" />
          <q-tooltip>Adicionar Atendimento</q-tooltip>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { ROUTE_SETTINGS, ROUTE_ATTENDANCE_NEW } from '@/router/constants'
import NumKeyboardAndPlus from '@/assets/icons/numKeyboardAndPlus.svg'

export default {
  components: {
    NumKeyboardAndPlus
  },

  data () {
    return {
      filter: ''
    }
  },

  computed: {
    ...mapState({
      isPaused: (_, getters) => getters['agentModule/isPauseLocked'],
      attendances: (state) => state.attendanceModule
    })
  },

  methods: {
    handleAdd () {
      const vm = this
      vm.$router.push({ name: ROUTE_ATTENDANCE_NEW }).catch(() => {})
      vm.$nextTick().then(() => vm.$root.$emit('focus-target-destination'))
    },

    handleSettings () {
      const vm = this
      vm.$router.push({ name: ROUTE_SETTINGS }).catch(() => {})
    }
  }
}
</script>

<style lang="sass" scoped>
.settings-icon
  width: 19px
  height: 19px

.settings-icon > path
  fill: #37474F

</style>
